import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { PBISPointItemAddRequest } from "./PBISPointItemAddRequest";
import { PBISPointItemUpdateRequest } from "./PBISPointItemUpdateRequest";

@Injectable()
export class DataService_PBISMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	PBISPointItemSelectFullInfoList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/PBISPointItemSelectFullInfoList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISPointItemToggle(PointsItemID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/PBISPointItemToggle?PointsItemID=" + PointsItemID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISPointsCategoryTypeGetList() {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/PBISPointsCategoryTypeGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISPointsCategoryGetList(PointsCategoryTypeID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/PBISPointsCategoryGetList?PointsCategoryTypeID=" + PointsCategoryTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISPointItemAdd(parms: PBISPointItemAddRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/PBISPointItemAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISPointItemUpdate(parms: PBISPointItemUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/PBISPointItemUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PointsItemInfoGetList(PointsItemID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/PointsItemInfoGetList?PointsItemID=" + PointsItemID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PointItemDelete(PointsItemID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/PointItemDelete?PointsItemID=" + PointsItemID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
